import { ServiceSold } from '@/pages/protected/Sales/components/services-sold-table/services-sold-tables.types';
import { Badge } from '@/components/ui/badge';
import { statusVariant } from '@/utils/sales';
import { format } from 'date-fns';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type TSaleInfo = {
  sale: ServiceSold;
};

export const SaleInfo = ({ sale }: TSaleInfo) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-1">
      <div>
        <h4 className="text-sm font-medium text-gray-500">
          {t('sales.sections.saleInfo.id')}
        </h4>
        <p>{sale.id}</p>
      </div>
      <div>
        <h4 className="text-sm font-medium text-gray-500">
          {t('sales.sections.saleInfo.createdAt')}
        </h4>
        <p>{format(sale.createdAt, "dd/MM/yy HH:mm'hs'")}</p>
      </div>
      <div>
        <h4 className="text-sm font-medium text-gray-500">
          {t('sales.sections.saleInfo.status')}
        </h4>
        <Badge variant={statusVariant[sale.status.name]}>
          {t(`tables.servicesSold.${sale.status.name}`)}
        </Badge>
      </div>
      <div>
        <h4 className="text-sm font-medium text-gray-500">
          {t('sales.sections.saleInfo.service')}
        </h4>
        <Link
          to={`/services/${sale.service.id}`}
          target="_blank"
          className="flex items-center gap-2 underline cursor-pointer text-primary"
        >
          <p>{sale.service.name}</p>
          <ExternalLink className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
